import { URL_REGEX, MAILTO_REGEXP } from '../../../../utils';

export const isURL = url => URL_REGEX.test(url);
export const isMailTo = url => MAILTO_REGEXP.test(url);
export const isNotEmpty = label => label.length > 0;
export const hasIcon = icon => icon.length >0;